var _a, _b;
import { getMetaValueRaw } from '@rad/utility/meta';
import { addRequestInterceptor } from '@rad/utility/http';
import { setWebSocketParams } from '@rad/utility/websocket';
// Where an organization without its own subdomain is served on the root host
export const communityPathFor = (subdomain) => `/o/${subdomain}`;
// On such a page, that prefix, which sits in front of every in-app URL; elsewhere ''
export const communityPath = (_a = getMetaValueRaw('76U-COMMUNITY-PATH')) !== null && _a !== void 0 ? _a : '';
const communitySubdomain = (_b = communityPath.split('/').filter(Boolean)[1]) !== null && _b !== void 0 ? _b : '';
// The host no longer says which community a request is for, so the page does, on every request.
export const configureCommunityRequests = () => {
    if (!communitySubdomain)
        return;
    addRequestInterceptor(init => (Object.assign(Object.assign({}, init), { headers: Object.assign(Object.assign({}, (init.headers || {})), { 'X-Community': communitySubdomain }) })));
    setWebSocketParams({ community: communitySubdomain });
};
// A URL built for this page, rebased for another host, where the prefix doesn't apply
export const withoutCommunityPath = (url) => communityPath && url.startsWith(communityPath) ? url.slice(communityPath.length) : url;
